/**
 * Konsolidierte Texte für „alle Studios“ / „all studios“.
 * Eine Stelle für alle Listen, Platzhalter und Tooltips.
 * Mit useI18n: text(allStudiosTexts.label) usw.
 */

export const allStudiosTexts = {
  /** Anzeige in Listen/Tabellen wenn Eintrag für alle Studios gilt */
  label: "All studios" as const,

  /** Platzhalter für Studio-Select (ohne Studios = alle) */
  placeholder: "(all studios)" as const,

  /** Tooltip: Leer = für alle Studios, Mehrfachauswahl möglich */
  tooltipEmptyMulti: "Empty = for all studios. Multiple selection." as const,

  /** Tooltip: Leer = alle Studios (kurz) */
  tooltipEmptyShort: "Empty = all studios." as const,

  /** Tooltip: Leer = für alle Studios verfügbar */
  tooltipEmptyAvailable: "Empty = available for all studios." as const,

  /** Tooltip: Leer = alle Studios, Mehrfachauswahl (z. B. Lead-Zuordnung) */
  tooltipEmptyMultiLead: "Empty = all studios. Multiple selection (e.g. for lead assignment)." as const,

  /** Tooltip: Leer = für alle Studios, Ressource (ResourcesPage) */
  tooltipEmptyMultiResource: "Empty = for all studios. Multiple selection – resource is then available in all selected studios (same availability)." as const,

  /** Tooltip: Leer = für alle Studios, Studios ohne Zugriff ausgegraut */
  tooltipEmptyMultiDisabled: "Empty = for all studios. Studios without access are disabled." as const,

  /** Platzhalter: Keine Auswahl = für alle Studios */
  placeholderNoSelection: "No selection = for all studios" as const,

  /** Hinweis: Wenn kein Studio ausgewählt, gilt für alle Studios */
  hintNoStudioAll: "If no studio is selected, the template applies to all studios." as const,

  /** Platzhalter: Studios auswählen */
  placeholderSelectStudios: "Select studios..." as const,

  /** Label: Erlaubte Studios */
  labelAllowedStudios: "Allowed studios" as const
} as const;
